<style>
#treeviewcuentacontable li {
  font-size: 1rem !important;
  cursor: pointer;
}
#treeviewcuentacontable li span:hover {
  text-decoration: underline;
}
</style>

<template>
  <div class="content-box">
    <div class="element-wrapper" v-if="!verEnArbol">
      <div class="element-box">
        <h5 class="form-header">Cuentas Contables</h5>
        <input class="btn btn-info" type="button" @click="verArbol" value="Ver Arbol">
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <a class href="#"></a>
              <a v-if="mostrarRefresh" class="btn btn-sm btn-info" @click="refreshData" href="#">Refresh</a>
            </div>
            <div class="col-sm-6">
              <form action="#" class="form-inline justify-content-sm-end">
                <input class="form-control form-control-sm rounded bright" placeholder="Search" v-model="searchtext"
                  type="text" />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="submit" @click="filterData">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <!-------------------- Tabla de REsultados -------------------->
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col">Id</th>
                <th scope="col">Nombre</th>
                <th scope="col" class="text-center">Activa?</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="current in data.results" v-bind:key="current.id">
                <td scope="row">{{ current.id }}</td>
                <td>{{ current.nombre }}</td>
                <td class="text-center">
                  <div v-if="current.estado" class="status-pill green" data-title="Activo" data-toggle="tooltip"></div>
                  <div v-if="!current.estado" class="status-pill red" data-title="Inactiva" data-toggle="tooltip"></div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
      </div>
    </div>
    <div class="element-wrapper" v-if="verEnArbol">
      <div class="element-box">
        <h5 class="form-header">Cuentas Contables</h5>
        <input class="btn btn-info" type="button" @click="verArbol" value="Ver en Tabla"/>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-12">
              <div id="treeviewcuentacontable" class="treeview w-20">
                <ul class="mb-1 pl-3 pb-2">
                  <li v-for="current in datatreeview" v-bind:key="current.id">
                    <i :class="{ 'fas fa-angle-down': open, 'fas fa-angle-right': !open}"></i>
                    <span @click="openclose">
                      <i class="os-icon os-icon-bar-chart-up ic-w mx-1"></i>{{ current.id }} - {{ current.nombre }}
                    </span>
                    <ConCuentacontableTreeViewItem v-for="current in current.hijos" v-bind:key="current.id"
                      :current="current" v-if="open"  />
                  </li>
                </ul>
                <hr>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import PaginationComponent from "@/components/utils/PaginationComponent";
import ConCuentacontableTreeViewItem from "@/components/conta/cuentas_contables/ConCuentacontableTreeViewItem";
import CuentaContableService from "@/services/conta/CuentaContableService";

export default {
  components: {
    PaginationComponent,
    ConCuentacontableTreeViewItem,
  },
  data() {
    return {
      verEnArbol: true,
      mostrarRefresh: false,
      currentPage: 0,
      searchtext: "",
      data: [],
      datatreeview: [],
      open: true,
    };
  },
  computed: {},
  mounted() {
    self.verArbol = true;
    this.refreshData();
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        tienda: this.filterActiva,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        tienda: this.filterActiva,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActiva = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        tienda: this.filterActiva,
      });
    },
    refreshData(params) {
      let self = this;
      if (!self.verEnArbol) {
        CuentaContableService.fetch(params).then((res) => {
          self.data = res.data;
          self.datatreeview = [];
        });
      } else {
        CuentaContableService.treeview().then((res) => {
          self.datatreeview = res.data;
          self.data = [];
        });
      }
    },
    showModalEdit() { },
    verArbol() {
      let self = this;
      self.verEnArbol = !self.verEnArbol;
      self.refreshData();
    },
    openclose() {
      this.open = !(this.open);
    }
  },
};
</script>
